import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Col, Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import MultiSelect from "components/common/MultiSelect"; // Adjust path as needed
import classNames from "classnames";
import {
  CancelPreauthorization,
  GetAllClaimPreAuthAllList,
  GetAllPreauthorizationList,
} from "../config/preauthorizationApi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";
import moment from "moment";

const CancelModal = ({ show, onClose, row, page, rowsPerPage }) => {
  const dispatch = useDispatch();
  const { cancelReasonList, preauthorizationFilters } = useSelector(
    (state) => state.preauthorization
  );

  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
  const navigate = useNavigate();

  useEffect(() => {
    if (show && cancelReasonList?.length === 0) {
      dispatch(GetAllClaimPreAuthAllList());
    }
  }, [show, dispatch, cancelReasonList]);

  const { watch, setValue, control, handleSubmit, reset } = useForm({
    defaultValues: {
      cancel_reason: null,
    },
  });

  const requestBody = () => ({
    branch_id: selectedBranch?.value || 1,
    insurance_company_id:
      preauthorizationFilters?.insurance?.insurance_company_id || "",
    claim_type:
      preauthorizationFilters?.preauthorization_type?.claim_types_id || "",
    claimsub_types_name:
      preauthorizationFilters?.preauthorization_sub_type?.claimsub_types_id ||
      "",
    ref_number: preauthorizationFilters?.reference_number || "",
    frm_dte: preauthorizationFilters?.start_date
      ? moment(preauthorizationFilters?.start_date).format("DD-MM-YYYY")
      : "",
    to_dte: preauthorizationFilters?.end_date
      ? moment(preauthorizationFilters?.end_date).format("DD-MM-YYYY")
      : "",
    ident_typ: preauthorizationFilters?.identity_type?.ident_type_id || "",
    pat_det: preauthorizationFilters?.patient || "",
    preauth_sts:
      preauthorizationFilters?.preauthorization_status?.allstatus_code || "",
    start_point: page,
    limit: rowsPerPage,
  });

  const fetchPreauthorizationList = async (body = {}) => {
    try {
      const response = await dispatch(
        GetAllPreauthorizationList(body)
      ).unwrap();
    } catch (error) {
      // toast.error("Something Went Wrong");
    }
  };

  const handleCheckListFilter = () => {
    const body = requestBody();
    fetchPreauthorizationList(body);
  };

  const handleCancel = async (data) => {
    const body = {
      preauthid:
        row?.preauthinspro_id ||
        row?.preauthpharmcy_id ||
        row?.preauthfull_id ||
        row?.preauthvision_id,
      cncl_reason: watch("cancel_reason")?.cnclrsn_code || null,
      claim_type: row?.claim_type,
    };

    const response = await dispatch(CancelPreauthorization(body)).unwrap();
    if (response?.status_code === "200") {
      toast.success(response?.message_en);
      navigate(`${paths.preauthorizationList}`);
      onClose();
      reset();
      handleCheckListFilter();
    } else {
      toast.error(
        `(${response?.data?.error_code}) - ${response?.data?.error_msg}`
      );
    }
  };

  return (
    <Modal show={show} centered dialogClassName="wizard-modal">
      <Form onSubmit={handleSubmit((data) => handleCancel(data))}>
        <Modal.Body>
          <FalconCloseButton
            size="sm"
            className="position-absolute top-0 end-0 me-2 mt-2"
            onClick={() => {
              onClose();
              reset();
            }}
          />
          <Flex direction="column" alignItems="center" className="mb-3">
            <h6 className="fs-9 text-700">Cancel Operation</h6>
            <h6 className="fs-11 text-400 ">
              Please select a reason for cancellation. This helps us improve
              future processes and address any potential concerns proactively.
            </h6>
          </Flex>

          <Col xs={12} className="mx-auto">
            <label className="form-label">
              Cancel Reason <span className="text-danger">*</span>
            </label>
            <Controller
              name="cancel_reason"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={true}
                  isMulti={false}
                  options={cancelReasonList?.map((item) => ({
                    value: item.cnclrsn_code,
                    label: item.cnclrsn_name,
                  }))}
                  value={
                    field.value
                      ? {
                          value: field.value.cnclrsn_code,
                          label: field.value.cnclrsn_name,
                        }
                      : null
                  }
                  onChange={(selected) => {
                    setValue(
                      "cancel_reason",
                      selected
                        ? {
                            cnclrsn_code: selected.value,
                            cnclrsn_name: selected.label,
                          }
                        : null
                    );
                  }}
                  formatOptionLabel={({ label }) => <div>{label}</div>}
                  getOptionValue={(option) => option.value}
                  placeholder="Choose ..."
                />
              )}
            />
          </Col>

          <hr />
          <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
            <Button variant="danger" size="sm" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="success" size="sm" type="submit">
              Submit
            </Button>
          </div>
        </Modal.Body>
      </Form>
    </Modal>
  );
};

CancelModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  control: PropTypes.any.isRequired,
  errors: PropTypes.object,
  watch: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  cancelReasonList: PropTypes.array.isRequired,
  isSubmitted: PropTypes.bool,
};

export default CancelModal;
